import React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DropdownText, MemberDiscountList } from "../../GlobalSearchHelpers";
import {
  LRR_LABEL,
  PACKAGE_LABEL,
  AUTO_LABEL,
  GOVERNMENT_LABEL,
  CORPORATE_LABEL,
  GROUP_LABEL,
} from "../../GlobalSearchProps";

export const GlobalSearchForm = (props: {
  discount: any;
  promotionCode: any;
  groupCode: any;
  showDiscounts: boolean;
  isSearchModal: any;
  handleDiscountsDropdown: any;
  isBrandHotelSearchModal: any;
  discountToggleText: any;
  handleDiscountChange: any;
  isLRR: any;
  handleShowPromo: any;
  showPromoField: any;
  handlePromotionCodeChange: any;
  handlePromotionCodeBlur: any;
  handleShowGroup: any;
  showGroupField: any;
  handleGroupCodeChange: any;
  handleGroupCodeBlur: any;
}): JSX.Element => {
  return (
    <Form.Group controlId="discount" className="mb-lg-0">
      <Form.Label
        srOnly
        htmlFor="dropdown-discounts"
        id="dropdown-discounts-label"
      >
        Select Rate Type
      </Form.Label>
      <Dropdown
        className={`discounts`}
        id="dropdown_discounts"
        show={props.showDiscounts !== false}
      >
        <Dropdown.Toggle
          variant="search-dropdown"
          className="form-control"
          id="dropdown-discounts"
          onClick={props.handleDiscountsDropdown}
          disabled={props.isSearchModal && !props.isBrandHotelSearchModal}
          aria-labelledby="dropdown-discounts-label"
        >
          <DropdownText discountToggleText={props.discountToggleText} />
          <FontAwesomeIcon icon="chevron-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className={`discounts-members`}>
            <MemberDiscountList>
              <li>
                <Dropdown.Item
                  eventKey={`LRR`}
                  onSelect={props.handleDiscountChange}
                  active={props.isLRR}
                  aria-label={LRR_LABEL}
                  id={`lrr-label`}
                >
                  <span>
                    {LRR_LABEL}
                    {props.isLRR && <FontAwesomeIcon icon="check" />}
                  </span>
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  eventKey={`PKG`}
                  onSelect={props.handleDiscountChange}
                  active={props.discount === `PKG`}
                  aria-label={PACKAGE_LABEL}
                  id={`package-label`}
                >
                  <span>
                    {PACKAGE_LABEL}
                    {props.discount === "PKG" && (
                      <FontAwesomeIcon icon="check" />
                    )}
                  </span>
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  eventKey={`AAA`}
                  onSelect={props.handleDiscountChange}
                  active={props.discount === `AAA` || props.discount === `AARP`}
                  aria-label={AUTO_LABEL}
                  id={`auto-label`}
                >
                  <span>
                    {AUTO_LABEL}
                    {props.discount === "AAA" && (
                      <FontAwesomeIcon icon="check" />
                    )}
                  </span>
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  eventKey={`GOV`}
                  onSelect={props.handleDiscountChange}
                  active={props.discount === `GOV`}
                  aria-label={GOVERNMENT_LABEL}
                  id={`government-label`}
                >
                  <span>
                    {GOVERNMENT_LABEL}
                    {props.discount === "GOV" && (
                      <FontAwesomeIcon icon="check" />
                    )}
                  </span>
                </Dropdown.Item>
              </li>
              <li id="promo-code">
                <Dropdown.Item
                  onSelect={props.handleShowPromo}
                  active={props.showPromoField}
                  aria-label={CORPORATE_LABEL}
                  id="corporate-promo"
                >
                  <span>
                    {CORPORATE_LABEL}
                    {props.showPromoField && <FontAwesomeIcon icon="check" />}
                  </span>
                  {props.showPromoField && (
                    <Form.Group
                      controlId={`promotionCode`}
                      className={`discounts-promotion`}
                    >
                      <Form.Label srOnly>{CORPORATE_LABEL}</Form.Label>
                      <Form.Control
                        className="input-wrapper"
                        name={`promotionCode`}
                        placeholder={`Enter code`}
                        onChange={props.handlePromotionCodeChange}
                        onBlur={props.handlePromotionCodeBlur}
                        defaultValue={
                          props.promotionCode ? props.promotionCode : ""
                        }
                      />
                    </Form.Group>
                  )}
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  onSelect={props.handleShowGroup}
                  active={props.showGroupField}
                  aria-label="Group"
                  id="group-code"
                >
                  <span>
                    Group
                    {props.showGroupField && <FontAwesomeIcon icon="check" />}
                  </span>
                  {props.showGroupField && (
                    <Form.Group
                      controlId={`groupCode`}
                      className={`discounts-group`}
                    >
                      <Form.Label srOnly>{GROUP_LABEL}</Form.Label>
                      <Form.Control
                        className="input-wrapper"
                        name={`groupCode`}
                        placeholder={`Enter code`}
                        onChange={props.handleGroupCodeChange}
                        onBlur={props.handleGroupCodeBlur}
                        defaultValue={props.groupCode ? props.groupCode : ""}
                      />
                    </Form.Group>
                  )}
                </Dropdown.Item>
              </li>
            </MemberDiscountList>
          </div>
          {props.isSearchModal ? (
            <div className="closeOffers">
              <Button
                variant="secondary"
                type={`button`}
                onClick={props.handleDiscountsDropdown}
                className={"closeButton"}
              >
                Close
              </Button>
            </div>
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    </Form.Group>
  );
};
